import { cn } from "../../lib/utils";
import { tenantLocale } from "../../lib/company";

const fmtMoney = (n) =>
  n == null ? "—" : `$${Number(n).toLocaleString(tenantLocale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/**
 * Three-tile reconciliation summary for the NTS Impound page.
 * Renders nothing when there are no rows to summarise — keeps the page
 * tidy in empty/loading states.
 */
export default function NtsReconciliation({ rows }) {
  if (!rows || rows.length === 0) return null;
  const totalDebt = rows.reduce((s, r) => s + (r.released_to_nts_amount_owed || 0), 0);
  const totalRecovered = rows.reduce((s, r) => s + (r.nts_sold_amount || 0), 0);
  const net = totalRecovered - totalDebt;
  return (
    <div className="grid grid-cols-3 gap-3" data-testid="nts-reconciliation">
      <div className="bg-rose-50 dark:bg-rose-950/30 border border-rose-200 dark:border-rose-800 rounded-md p-3">
        <div className="uppercase-label text-rose-700 dark:text-rose-300">Total Written Off</div>
        <div className="font-display text-2xl font-black text-rose-800 dark:text-rose-200 tabular-nums" data-testid="nts-total-debt">
          {fmtMoney(totalDebt)}
        </div>
      </div>
      <div className="bg-emerald-50 dark:bg-emerald-950/30 border border-emerald-200 dark:border-emerald-800 rounded-md p-3">
        <div className="uppercase-label text-emerald-700 dark:text-emerald-300">Total Recovered</div>
        <div className="font-display text-2xl font-black text-emerald-800 dark:text-emerald-200 tabular-nums" data-testid="nts-total-recovered">
          {fmtMoney(totalRecovered)}
        </div>
      </div>
      <div className={cn(
        "border rounded-md p-3",
        net >= 0
          ? "bg-blue-50 dark:bg-blue-950/30 border-blue-200 dark:border-blue-800"
          : "bg-amber-50 dark:bg-amber-950/30 border-amber-200 dark:border-amber-800"
      )}>
        <div className={cn(
          "uppercase-label",
          net >= 0 ? "text-blue-700 dark:text-blue-300" : "text-amber-700 dark:text-amber-300"
        )}>
          Net {net >= 0 ? "Profit" : "Loss"}
        </div>
        <div className={cn(
          "font-display text-2xl font-black tabular-nums",
          net >= 0
            ? "text-blue-800 dark:text-blue-200"
            : "text-amber-800 dark:text-amber-200"
        )} data-testid="nts-net">
          {net >= 0 ? "+" : ""}{fmtMoney(net)}
        </div>
      </div>
    </div>
  );
}
